'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Markdown;
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _remark = require('remark');
var _remark2 = _interopRequireDefault(_remark);
var _remarkReact = require('remark-react');
var _remarkReact2 = _interopRequireDefault(_remarkReact);
var _Markdown = require('./Markdown.css');
var _Markdown2 = _interopRequireDefault(_Markdown);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Markdown(_ref) {
  var content = _ref.content,
    className = _ref.className;
  var MarkdownComponent = (0, _remark2.default)().use(_remarkReact2.default).processSync(content).contents;
  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)(className, _Markdown2.default.wrapper)
  }, MarkdownComponent);
}
Markdown.propTypes = {
  content: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string
};